module.exports = __webpack_public_path__ + "img/table-bg.c333f13c.webp";